import { SelectChangeEvent, MenuItem, Typography, Select, Box } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { selectStyle } from '../../constants/styleConstants'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import {
  updateNewCaseAnswerOption,
  updateVictimAnswerOption,
} from '../../store/questions/questionsSlice'
import { IQuestionV2, MainObject } from '../../store/reports/types'

import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import FormLayout from '../forms/FormLayout'
import DividerTAG from '../DividerTAG'
import { questionParser } from '.'
import { findItemByUuid } from '../../store/reports/reportsSlice'
import colors from '../../constants/colors'

interface ISingleSelectQuestion {
  question: IQuestionV2
  victimQuestionId?: number | null
}

const SingleSelectQuestion: React.FC<ISingleSelectQuestion> = ({
  question,
  victimQuestionId = null,
}) => {
  const getAnswer = () => {
    if (victimQuestionId) {
      return useSelector(questionsSelector.getVictimAnswer(victimQuestionId, question?.uuid))
    }
    return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  }
  const answer = getAnswer()
  const dispatch = useDispatch<AppDispatch>()

  const optionsAndSubquestions = question?.options.map((option, index) => {
    const found = question?.subquestions.filter(subQuestion => subQuestion?.option == option.id)
    return found?.length > 0
      ? {
          option,
          subquestions: found,
        }
      : {
          option,
        }
  })
  const onChangeHandler = (event: SelectChangeEvent) => {
    if (victimQuestionId) {
      dispatch(
        updateVictimAnswerOption({
          victimId: victimQuestionId,
          answerUUID: answer?.uuid,
          answerText: [event.target.value as unknown as number],
        }),
      )
      return
    }
    dispatch(
      updateNewCaseAnswerOption({
        answerUUID: answer?.uuid,
        answerText: [event.target.value as unknown as number],
      }),
    )
  }

  const renderSelectOptions = () => {
    const whatToLoop =
      question.text_third === 'Did the reporting party identify themselves?'
        ? [
            { id: 1, text: 'Yes' },
            { id: 2, text: 'No' },
          ]
        : question.options
    return whatToLoop.map(({ id, text }) => {
      return (
        <MenuItem value={id} key={id}>
          <Typography variant='bodyBold'>{text}</Typography>
        </MenuItem>
      )
    })
  }

  /* eslint-disable */
  // // console.log("QUeSTION :  : ", question)

  const resolveSubquestionRender = () => {
    const filteredOptionsAndSubquestions = optionsAndSubquestions?.filter(option => {
      /* eslint-disable */
      // // console.log("OPTION : ", option)
      if (option?.option?.id === answer?.options[0]) return true
    })

    /* eslint-disable */
    // // console.log("filteredOptionsAndSubquestions : ", filteredOptionsAndSubquestions)

    if (filteredOptionsAndSubquestions.length > 0) {
      return filteredOptionsAndSubquestions?.map(option => {
        const hasChildQuestions = Object.prototype.hasOwnProperty.call(option, 'subquestions')
        if (hasChildQuestions) {
          return (
            <Box sx={{ width: '100%' }} key={option?.option?.id}>
              <FormLayout>
                <DividerTAG />
                {option?.subquestions?.map(subQuestion => {
                  /* eslint-disable */
                  // // console.log("subQuestion : ", subQuestion)
                  return questionParser(subQuestion, false, victimQuestionId)
                })}
              </FormLayout>
            </Box>
          )
        }

        return <></>
      })
    }

    return <></>
  }
  return (
    <FormLayout>
      {!question.is_root && (
        <Typography variant='bodyBold' color={colors.TAG_BLUE}>
          {question?.text_third}
        </Typography>
      )}
      {question.is_root && victimQuestionId && (
        <Typography variant='bodyBold' color={colors.TAG_BLUE}>
          {question?.text_third}
        </Typography>
      )}
      <Select
        onChange={onChangeHandler}
        value={(answer?.options[0] as unknown as string) ?? ''}
        IconComponent={ArrowIcon}
        displayEmpty
        sx={[selectStyle]}
      >
        {renderSelectOptions()}
      </Select>
      {resolveSubquestionRender()}
    </FormLayout>
  )
}

export default SingleSelectQuestion
